<template>
  <div class="form-area">
    <div class="form-title">
      如因提交錯誤個人資料以致申請失敗，本會恕不負責，請小心填寫</br>
     If the application is rejected due to the submission of inaccurate personal data, we will not be</br> responsible for the consequences.
      Please fill it out carefully.
    </div>


    <!-------------------- 第一位申请人基本信息 --------------------->
    <el-form :model="personData" :rules="personDataRules" ref="personData">
      <div v-if="isSingle">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="form-label">選擇入住單位類型（可多選一項）*</br>Select unit type (Can select more than one choice).</div>
            <el-form-item prop="unitType">
              <el-checkbox-group v-model="personData.unitType">
                <div class="form-checkbox">
                  <el-checkbox v-for="dict in dict.type.unitType" :key="dict.value" :label="dict.value">{{dict.label}}
                  </el-checkbox>
                </div>

              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <div class="form-tip-mid contact-desc"><i class="el-icon-question" />申請人可同時選擇申一人單位及 / 或 3
              人共居單位。如申請人只選擇其中一項單位類型，則
              PH2 將只考慮為該申請人安排入住所選的單位類別。</br>
              Applicants can choose either a single unit or a co-living unit for three persons .If</br>
              only chooses one type of unit for the application,PH2 will only offer the type of unit</br>
              chosen by the applicant.Please fill it out carefully.</div>
          </el-col>
        </el-row>
        <div class="line" />
      </div>

      <div class="form-title">
        請填寫閣下的聯絡方法</br>
        Please fill in your contact detail
      </div>



      <el-row :gutter="10" class="form-row">
        <el-col :span="4">
          <div class="form-label">中文姓名 *</br> Name (Chinese)</div>
        </el-col>
        <el-col :span="8">
          <div class="form-input">
            <el-form-item prop="nameChineseX">
              <el-input placeholder="姓" v-model="personData.nameChineseX"></el-input>
            </el-form-item>
          </div>
          <div style="margin-top:20px">
            <el-form-item prop="nameChineseM">
              <el-input placeholder="名" v-model="personData.nameChineseM"></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="form-tip-mid"><i class="el-icon-question" />請以繁體中文填寫(需與身份證相乎)</br>Please fill in traditional
            Chinese (same as ID card)</div>
        </el-col>
      </el-row>

      <el-row :gutter="10" class="form-row">
        <el-col :span="4">
          <div class="form-label">英文姓名 *</br> Name (English)</div>
        </el-col>
        <el-col :span="8">
          <div class="form-input">
            <el-form-item prop="nameEnglishF">
              <el-input placeholder="First Name 英文名稱" v-model="personData.nameEnglishF"></el-input>
            </el-form-item>
          </div>
          <div style="margin-top:20px">

            <el-form-item prop="nameEnglishL">
              <el-input placeholder="Last name 英文姓氏" v-model="personData.nameEnglishL"></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="form-tip-mid"><i class="el-icon-question" />請以英文正楷填寫（須與身份證相乎）</br>Please fill in
            capital letters (same as ID card)
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="10" class="form-row">
        <el-col :span="4">
          <div class="form-label">香港永久性居民身份證號碼 *</br> HK permanent ID card no.</div>
        </el-col>
        <el-col :span="8">
          <div class="form-input">
            <el-form-item prop="hkCardNo">
              <el-input placeholder="Ex:A1234567" v-model="personData.hkCardNo" maxlength="8"></el-input>
            </el-form-item>
          </div>
          <div class="form-tip-mid">
            （如 A123456 (7)，則只須填寫 A1234567。Such as A123456 (7), you need to
            fill in A1234567.）
          </div>
        </el-col>
        <el-col :span="12">
          <div class="form-tip-mid"><i class="el-icon-question" />當按下一步後，香港永久性居民身份證號碼將<span
              style="color:red">不可修改</span>，請小心填寫。</br>After pressing Next
            Step, the HK permanent ID card</br> no. <span style="color:red">cannot be modified</span>. Please fill out
            carefully.
          </div>
        </el-col>
      </el-row>


      <div class="promise">
        <el-form-item prop="confirm">
          <div class="center-form-checkbox">
            <el-checkbox v-model="personData.confirm">本人確定為香港永久性居民。I confirm my status as a
                permanent resident of the
                HKSAR.
            </el-checkbox>
          </div>
        </el-form-item>
      </div>


      <el-row :gutter="10" class="form-row">
        <el-col :span="4">
          <div class="form-label">出生日期 *</br> Date of birth</div>
        </el-col>
        <el-col :span="8">
          <div class="form-input">
            <el-form-item prop="birthDate">
              <el-date-picker type="date" :picker-options="pickerOptions" editable placeholder="2024-09-02"
                v-model="personData.birthDate">
              </el-date-picker>
            </el-form-item>
          </div>
          <div class="form-tip-large">
            日期格式：YYYY-MM-DD</br>Date Format: YYYY-MM-DD
          </div>
        </el-col>
        <el-col :span="12">
          <div class="form-tip-mid"><i class="el-icon-question" />當按下一步後，出生日期將<span
              style="color:red">不可修改</span>，請小心填寫。</br>
            输入提示：</br>
            1. 按月曆圖案以顯示月曆</br>
            2. 按 > 或 <轉換其它月份</br> 3. 申請者亦可在月曆旁的空白位置輸入日期，格式為 YYYY-MM-DD，例如 1994-06-16</br> After pressing Next Step, the
              date of birth<span style="color:red"> cannot be modified</span>. Please fill it out
              carefully.</br>
              Hint: </br> 1. Press the calendar
              icon to show the calendar</br> 2. Press> or < to change to other months</br> 3. Applicants can also enter
                the date in the blank space next to the calendar in the format YYYY-MM-DD, for example 1994-06-16.</br>
                </div> </el-col> </el-row> <el-row :gutter="10" class="form-row">
                <el-col :span="4">
                  <div class="form-label">性別 *</br>Gender</div>
                </el-col>
                <el-col :span="8">
                  <div class="form-input">
                    <el-form-item prop="gender">
                      <el-radio-group v-model="personData.gender" class="line-box">
                        <el-radio v-for="dict in dict.type.gender" :key="dict.value" :label="dict.value">{{dict.label}}
                        </el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                </el-col>
      </el-row>

      <el-row :gutter="10" class="form-row">
        <el-col :span="4">
          <div class="form-label">聯絡電話 *</br> Telephone no</div>
        </el-col>
        <el-col :span="8">
          <div class="form-input">
            <el-form-item prop="telephoneNo">
              <el-input placeholder="98765432" maxlength="8" v-model="personData.telephoneNo"
                @input="(v)=>(personData.telephoneNo=v.replace(/[^\d]/g,''))">
              </el-input>
            </el-form-item>
          </div>
          <div class="form-tip-mid">
            香港手提電話號碼</br>
            HK mobile phone no</br>
            此聯絡電話將用於申請者聯絡之用</br>
            The contact number will be used to receive  calls from HKFYG
          </div>
        </el-col>
        <el-col :span="12">
          <div class="form-tip-mid"><i class="el-icon-question" />請提供可聯絡到申請人之正確香港手提電話號碼，以供進一步聯絡申請人之用</br>Please provide
            the correct Hong Kong
            mobile phone number for further contact with the applicant.
          </div>
        </el-col>
      </el-row>
    </el-form>


    <!-------------------- 第二位申请人基本信息（多了个邮箱） --------------------->

    <el-form :model="personData2" :rules="personData2Rules" ref="personData2" v-if="!isSingle">
      <div class="form-title">
        請填寫第二位申請人聯絡方法<br>Please fill in second applicant's contact detail
      </div>

      <el-row :gutter="10" class="form-row">

        <el-col :span="4">
          <div class="form-label">中文姓名 *</br> Name (Chinese)</div>
        </el-col>
        <el-col :span="8">
          <div class="form-input">
            <el-form-item prop="nameChineseX">
              <el-input placeholder="姓" v-model="personData2.nameChineseX"></el-input>
            </el-form-item>
          </div>
          <div style="margin-top:20px">
            <el-form-item prop="nameChineseM">
              <el-input placeholder="名" v-model="personData2.nameChineseM"></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="form-tip-mid"><i class="el-icon-question" />請以繁體中文填寫(需與身份證相乎)</br>Please fill in traditional
            Chinese (same as ID card)</div>
        </el-col>
      </el-row>

      <el-row :gutter="10" class="form-row">
        <el-col :span="4">
          <div class="form-label">英文姓名 *</br> Name (English)</div>
        </el-col>
        <el-col :span="8">
          <div class="form-input">
            <el-form-item prop="nameEnglishF">
              <el-input placeholder="First Name 英文名稱" v-model="personData2.nameEnglishF"></el-input>
            </el-form-item>
          </div>
          <div style="margin-top:20px">
            <el-form-item prop="nameEnglishL">
              <el-input placeholder="Last name 英文姓氏" v-model="personData2.nameEnglishL"></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="form-tip-mid"><i class="el-icon-question" />請以英文正楷填寫（須與身份證相乎）</br>Please fill in
            capital letters (same as ID card)
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="10" class="form-row">
        <el-col :span="4">
          <div class="form-label">香港永久性居民身份證號碼 *</br> HK permanent ID card no.</div>
        </el-col>
        <el-col :span="8">
          <div class="form-input">
            <el-form-item prop="hkCardNo">
              <el-input placeholder="Ex:A1234567" v-model="personData2.hkCardNo" maxlength="8"></el-input>
            </el-form-item>
          </div>
          <div class="form-tip-mid">
            （如 A123456 (7)，則只須填寫 A1234567。Such as A123456 (7), you need to
            fill in A1234567.）
          </div>
        </el-col>
        <el-col :span="12">
          <div class="form-tip-mid"><i class="el-icon-question" />按下一步後，香港永久性居民身份證號碼將<span
              style="color:red">不可修改</span>，請小心填寫。</br>After pressing Next
            Step, the HK permanent ID card</br> no. <span style="color:red">cannot be modified</span>. Please fill out
            carefully.
          </div>
        </el-col>
      </el-row>


      <div class="promise">
        <el-form-item prop="confirm">
          <div class="center-form-checkbox">
            <el-checkbox v-model="personData2.confirm">本人確定為香港永久性居民。I confirm my status as a
                permanent resident of the
                HKSAR.
            </el-checkbox>
          </div>
        </el-form-item>
      </div>


      <el-row :gutter="10" class="form-row">
        <el-col :span="4">
          <div class="form-label">出生日期 *</br> Date of birth</div>
        </el-col>
        <el-col :span="8">
          <div class="form-input">
            <el-form-item prop="birthDate">
              <el-date-picker :picker-options="pickerOptions" editable type="date" placeholder="2024-09-02"
                v-model="personData2.birthDate" format>
              </el-date-picker>
            </el-form-item>
          </div>
          <div class="form-tip-large">
            日期格式：YYYY-MM-DD</br>Date Format: YYYY-MM-DD
          </div>
        </el-col>
        <el-col :span="12">
          <div class="form-tip-mid"><i class="el-icon-question" />當按下一步後，出生日期將<span
              style="color:red">不可修改</span>，請小心填寫。</br>
            输入提示：</br>
            1. 按月曆圖案以顯示月曆</br>
            2. 按 > 或 <轉換其它月份</br> 3. 申請者亦可在月曆旁的空白位置輸入日期，格式為 YYYY-MM-DD，例如 1994-06-16</br> After pressing Next Step, the
              date of birth<span style="color:red"> cannot be modified</span>. Please fill it out
              carefully.</br>
              Hint: </br> 1. Press the calendar
              icon to show the calendar</br> 2. Press> or < to change to other months</br> 3. Applicants can also enter
                the date in the blank space next to the calendar in the format YYYY-MM-DD, for example 1994-06-16.</br>
                </div> </el-col> </el-row> <el-row :gutter="10" class="form-row">
                <el-col :span="4">
                  <div class="form-label">性別 *</br>Gender</div>
                </el-col>
                <el-col :span="8">
                  <div class="form-input">
                    <el-form-item prop="gender">
                      <el-radio-group v-model="personData2.gender" class="line-box">
                        <el-radio v-for="dict in dict.type.gender" :key="dict.value" :label="dict.value">{{dict.label}}
                        </el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                </el-col>
      </el-row>

      <el-row :gutter="10" class="form-row">
        <el-col :span="4">
          <div class="form-label">聯絡電話 *</br> Telephone no</div>
        </el-col>
        <el-col :span="8">
          <div class="form-input">
            <el-form-item prop="telephoneNo">
              <el-input placeholder="98765432" v-model="personData2.telephoneNo" maxlength="8"
                @input="(v)=>(personData2.telephoneNo=v.replace(/[^\d]/g,''))">
              </el-input>
            </el-form-item>
          </div>
          <div class="form-tip-mid">
            香港手提電話號碼</br>
            HK mobile phone no</br>
            此聯絡電話將用於申請者聯絡之用</br>
            The contact number will be used to receive  calls from HKFYG
          </div>
        </el-col>
        <el-col :span="12">
          <div class="form-tip-mid"><i class="el-icon-question" />請提供可聯絡到申請人之正確香港手提電話號碼，以供進一步聯絡申請人之用</br>Please provide
            the correct Hong Kong
            mobile phone number for further contact with the applicant.
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="10" class="form-row" style="margin-top:0px">
        <el-col :span="4">
          <div class="form-label">電郵地址 *</br> Email</div>
        </el-col>
        <el-col :span="8">
          <div class="form-input">
            <el-form-item prop="email">
              <el-input v-model="personData2.email" placeholder="Ex: myname@example.com"></el-input>
            </el-form-item>
          </div>
          <div class="form-tip-mid">
            此電郵地址用於接收網上申請確認及申請編號等資訊</br>
            Email Address will be used to receive the confirmation email</br> of online application and application
            number.
          </div>
        </el-col>
        <el-col :span="12">
          <div class="form-tip-mid"><i class="el-icon-question" />當按下一步，電郵地址將<span
              style="color:red">不可修改</span>，請小心填寫。</br>After pressing Next
            Step, the email <span style="color:red">cannot be modified</span>. Please fill out
            carefully.
          </div>
        </el-col>
      </el-row>
    </el-form>




    <div class="btn-box">
      <el-col :span="4"></el-col>
      <el-button class="next-btn" type="warning"
        :disabled="isSingle ? !personData.confirm : !personData.confirm || !personData2.confirm" @click="nextSetp"
        round>下一步 Next</el-button>
    </div>
  </div>
</template>

<script>
  import {
    sendVerifyMail
  } from "@/assets/js/api.js";
  import {
    filterFormRulesData
  } from "@/utils/json/utils";
  export default {
    dicts: ["gender", "unitType"],
    created() {
      //优先从session里面拉取
      let cacheData = this.Session.get("applicationInfo");
      if (cacheData) {
        if (this.isSingle) {
          this.personData = cacheData.personalInfo;
        } else {
          //多人申请拿两个表单
          this.personData = cacheData.personalInfo.personData;
          this.personData2 = cacheData.personalInfo.personData2;
        }
      }
    },

    data() {
      return {
        personData: {
          unitType: [],
        },
        personData2: {},
        verifyEmail: this.Session.get("verifyEmail"), //验证邮箱
        isSingle: this.Session.get("formId") === 1, //是否为单人申请
        personDataRules: filterFormRulesData("personDataRules"),
        personData2Rules: filterFormRulesData("personData2Rules"),
        pickerOptions: {
          disabledDate(time) {
            // 获取当前日期  
            const now = new Date();
            // 计算18年前的日期  
            const eighteenYearsAgo = new Date(now);
            eighteenYearsAgo.setFullYear(now.getFullYear() - 18);
            //計算31歲
            const thirtyOneYearsAgo = new Date(now);
            thirtyOneYearsAgo.setFullYear(now.getFullYear() - 31);
           // 禁用31年前当天及之前的日期，以及18年前当天之后的日期
            return time.getTime() > eighteenYearsAgo.getTime() || time.getTime() <= thirtyOneYearsAgo.getTime();
          },

        },
      };
    },

    methods: {
      nextSetp() {
        //将验证邮箱绑入第一人
        this.personData.email = this.verifyEmail;
        if (this.isSingle) {
          //单人申请
          this.singleApply();
        } else {
          //双人申请
          this.doubleApply();
        }
      },

      singleApply() {
        //驗證表單
        this.$refs.personData.validate((valid) => {
          if (valid) {
            //单人直接发送邮箱验证
            const personInfo = {
              personData: this.personData,
              personData2: null,
            };
            this.Session.set("personalInfo", personInfo);
            this.sendEmailCode();
          } else {
            console.log("error submit!!");
            this.validFail();
            return false;
          }
        });
      },
      doubleApply() {
        let valid1 = this.$refs.personData.validate();
        let valid2 = this.$refs.personData2.validate();
        let formArr = [valid1, valid2];
        Promise.all(formArr)
          .then(() => {
            console.log("application两个表单验证通过");
            // 执行后续操作
            const personInfo = {
              personData: this.personData,
              personData2: this.personData2,
            };
            this.Session.set("personalInfo", personInfo);
            this.sendEmailCode();
          })
          .catch(() => {
            console.log("至少有一个表单验证失败");
            this.validFail();
            return false;
          });
      },
      // 校验未通过时的处理
      validFail() {
        // 定位到错误信息位置
        setTimeout(() => {
          let isError = document.getElementsByClassName("is-error");
          isError[0].querySelector("input").focus();
        }, 100);
        this.$message.warning("請填寫紅色必填欄目");
      },

      //发送邮箱验证码
      sendEmailCode() {
        if (this.verifyEmail && this.personData) {
          const param = {
            verifyEmail: this.verifyEmail,
            cnName: this.personData.nameChineseX + this.personData.nameChineseM,
            enName: this.personData.nameEnglishL + " " + this.personData.nameEnglishF,
          };
          //申请前邮箱认证
          sendVerifyMail(param).then((res) => {
            console.log("创建申请邮箱认证返回" + JSON.stringify(res));
            this.$store.dispatch("NEXT_STEP", {
              changeStep: true,
              operateName: "emailVerify",
            });
          });
        }
      },
    },
  };

</script>

<style scoped>
  .promise {
    margin-top: 15px;
    line-height: 28px;
    font-size: 12px;
    color: #000000;
  }

  .line-box {
    display: flex !important;
  }

</style>



// WEBPACK FOOTER //
// src/view/apply/child/personalInfo.vue